module.exports = __webpack_public_path__ + "media/images/weather/30_night_g-4f035a3d3fb40466935886098ee6f3bf.png";